<h3>User information</h3>

<mat-card class="m-15 p-0! flex flex-row! justify-between gap-20 primary-icon">
  @for (info of infoMap; track info) {
    <article class="flex items-center justify-center py-20 p-15">
      <mat-icon class="size-30! text-30! mr-20">{{ info.icon }}</mat-icon>
      <div class="grid grid-rows-2 gap-y-10">
        <span class="body-2">{{ info.label }}</span>
        <span class="subtitle-2 min-h-[19px]">{{ currentUserService.currentUserValue?.[info.value] }}</span>
      </div>
    </article>
  }
  <button matIconButton (click)="openEditUserModal(); $event.stopPropagation()">
    <mat-icon class="size-18! text-18!">edit</mat-icon>
  </button>
</mat-card>
